import controller from '../../../../Scripts/Controller.js';

function ExpandControl(element) {

    function init() {
        element.addEventListener('click', (e) => {
            element.parentNode.parentNode.classList.toggle("expanded");
        })
    }

    return {
        init: init
    }

}

controller.add('ExpandControl', ExpandControl);
export default ExpandControl;
